import { ChangeDetectorRef, Component, Inject, Injector, INJECTOR, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { NanoService } from 'src/app/shared/nano/nano.service';
import {
  PrivyRoomRecord,
  RoomWithData,
} from 'src/app/shared/server-services/query-records/room-records';
import { RoomService } from 'src/app/shared/server-services/room.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NanoDialogBaseComponent } from '../../nano-base-dialog';

@Component({
  selector: 'app-admin-add-backup-dialog',
  templateUrl: './admin-add-backup-dialog.component.html',
  styleUrl: './admin-add-backup-dialog.component.scss',
})
export class AdminAddBackupDialogComponent
  extends NanoDialogBaseComponent<AdminAddBackupDialogComponent>
  implements OnInit
{
  form = new FormGroup({
    room_id: new FormControl('', { validators: [Validators.required] }),
  });

  public allRooms: RoomWithData[] = [];
  public allPrivyRooms: (PrivyRoomRecord & { info?: { name; version } })[] = [];

  constructor(
    private roomService: RoomService,
    @Inject(INJECTOR) injector: Injector,
    private nanoService: NanoService,
    private cd: ChangeDetectorRef, //@Inject(MAT_DIALOG_DATA) public data,
    private dialogService: DialogService
  ) {
    super(injector);
    roomService.getAllRoom().then((rooms) => {
      this.allRooms = <RoomWithData[]>rooms;
    });
    roomService.getPrivyRooms().then((rooms) => {
      rooms
        .filter((privy) => privy.lastActive && privy.sessionId)
        .forEach((r) => {
          r['isPrivy'] = true;
          this.nanoService.privyGetInfo(
            r,
            (info) => {
              console.log('info', info);
              r['info'] = info;
              this.cd.detectChanges();
            },
            (err) => {
              console.log('could not load privy room info', err);
              this.cd.detectChanges();
            }
          );
        });
      this.allPrivyRooms = rooms;
    });
  }

  ngOnInit(): void {}

  public addBackup() {
    this.dialogRef.close(this.form.value);
  }

  public visibilityChangeOnRoom(roomId) {
    this.roomService.getRoom(roomId).then(() => {
      this.cd.detectChanges();
    });
  }

  public selectedRoom;
  public selectRoom(room) {
    this.form.get('room_id').setValue(room.roomId || room.id);
    this.selectedRoom = room;
  }

  public deletePrivy(roomId) {
    this.dialogService
      .openConfirmDialog(
        marker('Are you sure?'),
        marker('Are you sure you want to delete this Backup Agent?'),
        marker('Delete'),
        marker('Cancel')
      )
      .subscribe((res) => {
        if (!res) return;

        this.roomService
          .deletePrivyRoom(roomId)
          .then((res) => {
            console.log('res', res);
            let ind = this.allPrivyRooms.findIndex((r) => r.roomId == roomId);
            if (ind > -1) {
              this.allPrivyRooms.splice(ind, 1);
              this.cd.detectChanges();
            }
            this.selectedRoom = undefined;
          })
          .catch((err) => {
            console.log('err', err);
            this.dialogService.openAlertDialog(
              marker('Backup Agent delete failed'),
              marker('Error happened during the process')
            );
          });
      });
  }
}
